<template>
  <div>
    <b-card :title="$t('settings.engineeringOffice.details')">

      <center v-if="loading">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <div v-else>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <strong>اسم المكتب الهندسي:</strong> {{ engineeringOffice.office_name }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <strong>رقم القيد:</strong> {{ engineeringOffice.registration_number }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <strong>اسم المالك:</strong> {{ engineeringOffice.owner_name }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          ><strong>التخصص:</strong>
            <span v-if="engineeringOffice.specialization_label">{{ engineeringOffice.specialization_label }}</span>
            <span v-else>{{ specializationName(engineeringOffice.specialization) }}</span>
          </b-col>
          <b-col
            cols="12"
            md="6"
          ><strong>المحافظة:</strong>
            {{ engineeringOffice.governorate ? engineeringOffice.governorate.name_ar : '-' }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <strong>الهاتف:</strong> {{ engineeringOffice.phone || '-' }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <strong>البريد الإلكتروني:</strong> {{ engineeringOffice.email || '-' }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <strong>العنوان:</strong> {{ engineeringOffice.address || '-' }}
          </b-col>
          <b-col
            cols="12"
            md="6"
          ><strong>تاريخ انتهاء الترخيص:</strong>
            {{ formatDate(engineeringOffice.license_expiry_date) }}
            <b-badge
              v-if="engineeringOffice.is_license_expired"
              variant="danger"
            >
              منتهي
            </b-badge>
            <b-badge
              v-else-if="engineeringOffice.is_license_expiring_soon"
              variant="warning"
            >
              ينتهي قريبًا
            </b-badge>
          </b-col>
          <b-col
            cols="12"
            md="6"
          ><strong>الحالة:</strong>
            <b-badge :variant="engineeringOffice.is_active ? 'success' : 'secondary'">
              {{ engineeringOffice.is_active ? 'نشط' : 'غير نشط' }}
            </b-badge>
          </b-col>
        </b-row>
      </div>

      <!-- Activity Logs Section -->
      <b-row
        v-if="hasPermission('view activity_logs') && engineeringOffice"
        class="mt-3"
      >
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'engineering-office'"
              :model-id="Number($route.params.id)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton, BSpinner, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  components: {
    BCard, BButton, BSpinner, BRow, BCol, BBadge, ActivityLogs,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      engineeringOffice: 'engineeringOffices/engineeringOffice',
      loading: 'engineeringOffices/load',
    }),
  },
  mounted() {
    this.fetchEngineeringOffice()
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
    fetchEngineeringOffice() {
      this.$store.dispatch('engineeringOffices/get', this.$route.params.id)
    },
    specializationName(specialization) {
      return this.$t(`settings.engineeringOffice.specializations.${specialization}`)
    },
    formatDate(dateString) {
      if (!dateString) return null
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return dateString
      }
    },
  },
}
</script>
